import Loading from 'components/Loading'
import OutfitSlider from 'components/OutfitSlider'
import OutfitTile from 'components/OutfitTile'
import Pagination from 'components/Pagination'
import { navigateClient } from 'helpers/navigation'
import { generateUrl } from 'helpers/pagination'
import { SectionTrackingContextProvider } from 'helpers/tracking/SectionTrackingContext'
import { inject, observer } from 'mobx-react'
import * as R from 'ramda'
import React from 'react'
import { translate } from 'react-i18next'
import { IStoreProvider } from 'store'
import styled, { css } from 'styled-components'
import { granite } from 'uiComponents/constants/colors'
import { fsXS } from 'uiComponents/constants/typography'
import { LIMIT_OUTFIT_RECOS } from '../../constants'

const outfitTitleCustomStyles = css`
  font-size: ${fsXS}px;
  color: ${granite};
`

const LoadingOutfits = styled.div<{ loadingOutfits: boolean }>`
  ${({ loadingOutfits }) =>
    loadingOutfits &&
    css`
      opacity: 0.5;
    `}
`

const MarginCorrection = styled.div`
  width: auto;
  margin: 0 -10px;
`

const RecoWrapper = styled.div`
  margin: 60px 0;
`

const LoadingContainer = styled.div`
  position: relative;
  width: 100%;
  margin-top: 58px;
`

class OutfitTileGrid extends React.Component<any, any> {
  renderPagination = () => {
    const { oopStore, urlManagerStore } = this.props
    const { currentPage, totalPages } = oopStore.pagination

    const onPageChange = data => {
      const selectedPage = ++data.selected
      const newUrl = generateUrl({
        page: selectedPage,
        pathname: urlManagerStore.pathname,
        params: urlManagerStore.params,
      })

      navigateClient({
        to: newUrl,
        router: null,
        urlManagerStore,
      })

      oopStore.switchToPage(
        selectedPage,
        oopStore.currentOutfits,
        LIMIT_OUTFIT_RECOS,
      )
    }

    const pageHrefBuilder = (page: number) =>
      generateUrl({
        page,
        pathname: urlManagerStore.pathname,
        params: urlManagerStore.params,
      })

    if (totalPages <= 1) {
      return null
    }

    return (
      <Pagination
        key={currentPage}
        disableInitialCallback={true}
        initialPage={R.dec(currentPage)}
        onPageChange={onPageChange}
        marginPagesDisplayed={1}
        pageCount={totalPages}
        pageRangeDisplayed={currentPage === totalPages ? 4 : 2}
        hrefBuilder={pageHrefBuilder}
      />
    )
  }

  renderOutfits = outfitIds => {
    const { oopStore } = this.props

    return R.splitEvery(12, outfitIds).map(group => (
      <SectionTrackingContextProvider key={group}>
        <MarginCorrection className="row">
          {group.map(id => (
            <LoadingOutfits
              loadingOutfits={oopStore.loadingOutfits}
              className="col-sm-6 col-md-4"
              key={id}
            >
              <OutfitTile
                id={id}
                hasCta={true}
                showIdolImage={true}
                customStyles={{ outfitTitle: outfitTitleCustomStyles }}
                pageType={null}
              />
            </LoadingOutfits>
          ))}
        </MarginCorrection>
      </SectionTrackingContextProvider>
    ))
  }

  renderOutfitReco = () => {
    const { t, isTablet } = this.props
    const { fashionIdolRecoOutfitIds } = this.props.oopStore

    if (fashionIdolRecoOutfitIds.length === 0) {
      return null
    }

    return (
      <RecoWrapper className="row">
        <OutfitSlider
          outfitIds={fashionIdolRecoOutfitIds}
          showIdolImage
          headline={t('Deine Fashion Idols')}
          slidesToShow={isTablet ? 2 : 3}
          slidesToScroll={isTablet ? 2 : 3}
          pageType={null}
        />
      </RecoWrapper>
    )
  }

  render() {
    const { isTablet } = this.props
    const { outfitIds, loadingOutfits } = this.props.oopStore
    const firstOutfits = isTablet ? 4 : 6

    if (loadingOutfits && !outfitIds.length) {
      return (
        <LoadingContainer>
          <Loading isCentered={true} />
        </LoadingContainer>
      )
    }

    return (
      <React.Fragment>
        {this.renderOutfits(R.take(firstOutfits, outfitIds))}
        {this.renderOutfitReco()}
        {outfitIds.length > firstOutfits &&
          this.renderOutfits(
            R.takeLast(outfitIds.length - firstOutfits, outfitIds),
          )}
        {this.renderPagination()}
      </React.Fragment>
    )
  }
}

export default translate()(
  inject((store: IStoreProvider) => {
    return {
      oopStore: store.outfitOverviewStore,
      isTablet: store.uiStore.matchedMedia === 'sm',
      urlManagerStore: store.urlManagerStore,
    }
  })(observer(OutfitTileGrid)),
)
